export enum NotificationStatus{
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Error = 'error'
}